(function () {
  'use strict';

  if (window.BuzzkoWishlistAuth) return;

  var PENDING_KEY = 'buzzko:wishlist:pending-auth:v1';
  
  var currentIntent = null;    
  var pendingPayload = null;   

  /* ---------- storage ---------- */
  function savePending(payload) {
    try { sessionStorage.setItem(PENDING_KEY, JSON.stringify(payload)); } catch (e) {}
  }
  function getPending() {
    try { var v = sessionStorage.getItem(PENDING_KEY); return v ? JSON.parse(v) : null; } catch (e) { return null; }
  }
  function clearPending() {
    pendingPayload = null;
    try { sessionStorage.removeItem(PENDING_KEY); } catch (e) {}
  }

  /* ---------- auth state ---------- */
  function isCustomerSignedIn() {
    if (document.documentElement.dataset.buzzkoCustomerSignedIn === 'true') return true;
    
    var signedIn = false;

    // 1. Check native Shopify cookie (Google Login)
    if (/(^|;\s*)logged_in_customer_id=/.test(document.cookie)) {
      signedIn = true;
    }

    // 2. THE OTP FIX: Check for OTP frontend signs
    if (!signedIn) {
      if (document.querySelector('a[href*="/account/logout"], [href*="logout"], [data-otp-logout]')) {
        signedIn = true;
      } else {
        try {
           for (var i = 0; i < localStorage.length; i++) {
               var k = localStorage.key(i).toLowerCase();
               if (k.includes('otp') || k.includes('auth') || k.includes('token') || k.includes('customer')) {
                   var v = localStorage.getItem(localStorage.key(i));
                   if (v && v.length > 10 && v !== 'false' && v !== 'null') {
                     signedIn = true;
                     break;
                   }
               }
           }
        } catch(e) {}
      }
    }

    // 3. HEAL THE DOM STATE
    if (signedIn) {
      document.documentElement.dataset.buzzkoCustomerSignedIn = 'true';
    }

    return signedIn;
  }

  function ensureHeaderBadge() {
    var link = document.querySelector('.buzzko-header-wishlist');
    if (!link || link.querySelector('[data-buzzko-wishlist-count]')) return;
    var badge = document.createElement('span');
    badge.className = 'buzzko-wishlist-count';
    badge.setAttribute('data-buzzko-wishlist-count', '');
    badge.setAttribute('data-count', '0');
    badge.setAttribute('aria-live', 'polite');
    badge.textContent = '0';
    link.appendChild(badge);
  }

  function markSignedIn() {
    document.documentElement.dataset.buzzkoCustomerSignedIn = 'true';
    ensureHeaderBadge();
    if (window.BuzzkoWishlist && typeof window.BuzzkoWishlist.refresh === 'function') {
      window.BuzzkoWishlist.refresh();
    }
  }

  /* ---------- pending actions ---------- */
  function applyPendingWishlist(payload) {
    if (!payload || !payload.productId || !window.BuzzkoWishlist) return;
    
    var alreadySaved = (payload.variantId && window.BuzzkoWishlist.hasVariant) 
      ? window.BuzzkoWishlist.hasVariant(payload.variantId) 
      : window.BuzzkoWishlist.hasProduct(payload.productId);

    if (!alreadySaved && window.BuzzkoWishlist.toggle) {
      window.BuzzkoWishlist.toggle(payload);
    }
    
    if (window.BuzzkoWishlist.refresh) window.BuzzkoWishlist.refresh();
  }

  function recoverAfterRedirect() {
    var payload = getPending();
    if (!payload || !isCustomerSignedIn()) return;
    clearPending();
    applyPendingWishlist(payload);
  }

  function checkAuthentication() {
    var intent = currentIntent;
    currentIntent = null; 

    window.setTimeout(function () {
      if (isCustomerSignedIn()) {
        markSignedIn();
        if (intent === 'product') {
          var payload = pendingPayload || getPending();
          clearPending();
          if (payload) applyPendingWishlist(payload);
        } else {
          clearPending(); 
        }
      }
    }, 500);
  }

  /* ---------- entry points ---------- */
  function openOtpModal() {
    var trigger = document.querySelector('.header__icon--account, shopify-account, [data-otp-login]');
    if (trigger) { trigger.click(); return true; }
    return false;
  }

  function handleWishlistClick(button, payload) {
    // If they are signed in (OTP or Google), this returns true and heals the dataset.
    if (isCustomerSignedIn()) {
      
      // 1. Ensure the header badge exists so the count can be seen
      markSignedIn(); 
      
      // 2. We handle the toggle manually so buzzko-wishlist.js doesn't un-fill the heart!
      if (window.BuzzkoWishlist && window.BuzzkoWishlist.toggle) {
        var nowAdded = window.BuzzkoWishlist.toggle(payload);
        
        // 3. Force the heart to fill/unfill instantly
        if (button) {
          button.classList.toggle('is-active', nowAdded);
          button.setAttribute('aria-pressed', nowAdded ? 'true' : 'false');
        }
        
        // 4. Force the header count to update instantly
        if (window.BuzzkoWishlist.refresh) {
          window.BuzzkoWishlist.refresh();
        }
      }
      
      // Return true tells buzzko-wishlist.js to stop and not interfere
      return true; 
    }
    
    if (!payload || !payload.productId || !payload.handle) return true;

    currentIntent = 'product';
    pendingPayload = payload;
    savePending(payload);

    window.__buzzkoAuthIntent = 'product';

    if (!openOtpModal()) {
      currentIntent = null; window.__buzzkoAuthIntent = null; clearPending();
      return false;
    }
    return true;
  }

  function handleHeaderWishlistClick(event) {
    if (isCustomerSignedIn()) return;
    event.preventDefault();
    currentIntent = 'view';
    
    window.__buzzkoAuthIntent = 'view';

    if (!openOtpModal()) {
      currentIntent = null; window.__buzzkoAuthIntent = null;
      window.location.assign('/account/login?return_url=' + encodeURIComponent(window.location.pathname));
      return;
    }
  }

  /* ---------- init ---------- */
  function init() {
    recoverAfterRedirect();

    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('[data-buzzko-wishlist-link]');
      if (!link) return;
      handleHeaderWishlistClick(event);
    });

    document.addEventListener('click', function (event) {
      if (event.target.closest && event.target.closest('.otp-account-modal__close, .otp-account-modal-backdrop')) {
        if (document.getElementById('otp-nca-account-modal')) checkAuthentication();
      }
    });

    window.addEventListener('focus', function() {
      if (currentIntent || getPending()) checkAuthentication();
    });
  }

  window.BuzzkoWishlistAuth = {
    handleWishlistClick: handleWishlistClick,
    handleHeaderWishlistClick: handleHeaderWishlistClick,
    isCustomerSignedIn: isCustomerSignedIn
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();